
// export Img component that displays <img /> but also displays loader during loading and then fadein image
import React, { Component } from 'react';
import Loader from './Loader';
import './Img.scss';

export default function Img({ src, style, loader, ...props }) {

    // implement loader
    const [isLoading, setIsLoading] = React.useState(false);
    const imgRef = React.useRef(null);

    React.useEffect(() => {
        imgRef.current = new Image();
        imgRef.current.onload = () => setIsLoading(false);
        imgRef.current.onerror = () => setIsLoading(false);

        imgRef.current.src = src;

        // set isLoaded  to true if already loaded
        if (imgRef.current.complete) {
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
        return () => {
            imgRef.current.onload = null;
            imgRef.current.onerror = null;
        }
    }, [src]);

    if (!loader) {
        loader = <Loader visible />
    }

    return (
        <div className='Img'>
            {isLoading ? loader : null}
            <img {...props} style={{ ...style, opacity: isLoading ? 0 : 1, transition: 'opacity 0.2s linear' }} src={src} />
        </div>
    );
    return <img {...props} src={src} />

}